import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { first, map } from "rxjs/operators";
import { IPerson } from "src/app/interfaces";
import { NotificationFacade } from "src/app/notifications/services/notification.facade";
import { NavigationService } from "src/app/services";
import { UserFacade } from "src/app/user/services/user.facade";
import { SubSink } from "subsink";
import { Substitute } from "../../models/substitute";
import { AbstractSubstituteService } from "../../substitute.service";
@Component({
    selector: "substitute-admin-view",
    templateUrl: "./admin-view.component.html",
    standalone: false
})
export class AdminViewComponent implements OnInit, OnDestroy {
  public substitute$: Observable<Substitute[]>;
  private subsink = new SubSink();
  constructor(
    private service: AbstractSubstituteService,
    private navService: NavigationService,
    private userFacade: UserFacade,
    private notificationFacade: NotificationFacade
  ) {}

  ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }
  ngOnInit(): void {
    this.substitute$ = this.service.getAll();
  }

  onEdit(s: Substitute): void {
    this.navService.toAdminSubstituteEdit(s.userId);
  }

  onDelete(s: Substitute): void {
    this.subsink.sink = this.service.delete(s.userId).subscribe(
      () => {
        this.notificationFacade.success(
          "substitute.component.user.delete.success"
        );
        this.substitute$ = this.service.getAll();
      },
      () =>
        this.notificationFacade.showError(
          "substitute.component.user.delete.fail"
        )
    );
  }

  onNewEditClick(p: IPerson): void {
    this.userFacade
      .getUserByLogin(p.login)
      .pipe(
        map((u) => u.id),
        first()
      )
      .subscribe((userId) => this.navService.toAdminSubstituteEdit(userId));
  }
}
